import { Scanner } from './Scanner';
import { Token, type TokenType } from './Token';

export const EOT = 'EOT' as TokenType;

export class Parser extends Scanner {
  // Check if we've reached the end of the input.
  get isEOT(): boolean {
    return this.pos >= this.tokens.length;
  }

  get current(): Token {
    if (this.isEOT) {
      return new Token('', {
        start: this.text.length,
        end: this.text.length,
        type: EOT
      });
    }
    return this.tokens[this.pos];
  }

  consume(): Token {
    const token = this.current;
    this.pos++;
    return token;
  }

  consumeToken(type: TokenType): Token | undefined {
    if (this.isEOT) {
      return undefined;
    }
    if (this.current.type === type) {
      return this.consume();
    }
    return undefined;
  }
}
